import React from 'react';
import { useQuery } from '@apollo/client';
import { Field } from '../../components/Form';
import LoadingIndicator from '../../components/LoadingIndicator';
import { gql } from '../../graphql/generated/gql';
import type { GitRepoPlatform } from '../../graphql/generated/graphql';

const GIT_REPOS_QUERY = gql(/** @complexity 4 */ `
  query gitRepos($platform: GitRepoPlatform!) {
    repos: gitRepos(platform: $platform) {
      owner
      name
    }
  }
`);

interface GitRepoCheckboxesProps {
  name: string;
  platform: GitRepoPlatform;
}

const GitRepoCheckboxes = ({
  name: fieldName,
  platform,
}: GitRepoCheckboxesProps) => {
  const { data, loading } = useQuery(GIT_REPOS_QUERY, {
    variables: { platform },
  });

  if (loading) {
    return <LoadingIndicator delay={0} />;
  }

  if (!data?.repos) {
    return <>Could not load repos.</>;
  }

  if (!data.repos.length) {
    return <>No repo found.</>;
  }

  return (
    <>
      {data.repos.map(({ owner, name: repoName }) => {
        const fullName = `${owner}/${repoName}`;

        return (
          <Field
            key={fullName}
            label={fullName}
            name={fieldName}
            type="checkbox"
            value={fullName}
          />
        );
      })}
    </>
  );
};

export default GitRepoCheckboxes;
